import Colors from "@constants/Colors";
import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledRootBox = styled(Box)<{
  isDesktop?: boolean;
}>`
  padding: ${(props) => (props.isDesktop ? "36px" : "")};
  gap: ${(props) => (props.isDesktop ? "24px" : "")};
  background-color: ${Colors.neutralwhite_50};
  display: ${(props) => (props.isDesktop ? "flex" : "")};
  flex-wrap: ${(props) => (props.isDesktop ? "wrap" : "")};
`;

export const CustomCardWrapper = styled.div<{
  isDesktop?: boolean;
}>`
  top: 164px;
  padding: ${(props) =>
    props.isDesktop ? "" : "16px 16px 0px 16px"} !important;
  max-width: ${(props) => (props.isDesktop ? "360px" : "")};
  min-width: ${(props) => (props.isDesktop ? "350px" : "")};
`;
